export const LayerType = {
    BackgroundImage: 'BackgroundImage',
    TextOverlay: 'TextOverlay',
    ComponentWidget: 'ComponentWidget',
} as const;

export type LayerType = typeof LayerType[keyof typeof LayerType];

export interface LayerPosition {
    top?: string | null;
    left?: string | null;
    right?: string | null;
    bottom?: string | null;
    width?: string | null;
    height?: string | null;
}

export interface LayerStyle {
    fontSize?: string | null;
    color?: string | null;
    fontWeight?: string | null;
    textAlign?: string | null;
    fontFamily?: string | null;
    backgroundColor?: string | null;
}

export interface LayerRenderData {
    layerKey?: string | null;
    layerType: LayerType;
    zIndex: number;
    imageUrl?: string | null;
    textContent?: string | null;
    position?: LayerPosition;
    style?: LayerStyle;
    componentType?: string | null;
    componentData?: Record<string, unknown> | null;
}
